import { localize } from "@/utils/i18n";

const textLocalize = {
    title: localize({
        ru: 'Подать заявку',
        en: 'Submit application',
        cn: 'Submit application'
    }),
    programs: localize({
        ru: 'Программа',
        en: 'Program',
        cn: 'Program'
    }),
    firstName: localize({
        ru: 'Фамилия',
        en: 'Lastname',
        cn: 'Lastname'
    }),
    secondName: localize({
        ru: 'Имя',
        en: 'Firstname',
        cn: 'Firstname'
    }),
    thirdName: localize({
        ru: 'Отчество',
        en: 'Patronymic',
        cn: 'Patronymic'
    }),
    dob: localize({
        ru: 'Дата рождения',
        en: 'Date of Birth',
        cn: 'Date of Birth'
    }),
    phone: localize({
        ru: 'Номер телефона',
        en: 'Phone number',
        cn: 'Phone number'
    }),
    email: localize({
        ru: 'Email',
        en: 'Email',
        cn: 'Email'
    }),
    studyPlace: localize({
        ru: 'Учебное заведение',
        en: 'Educational institution',
        cn: 'Educational institution'
    }),
    vuz: {
        label:  localize({
            ru: 'вуз',
            en: 'vuz',
            cn: 'vuz'
        }),
    },
    ssuz: {
        label:  localize({
            ru: 'ссуз',
            en: 'ssuz',
            cn: 'ssuz'
        }),
    },
    institutionName: localize({
        ru: 'Название учебного заведения',
        en: 'Institution name',
        cn: 'Institution name'
    }),
    levelEducation: localize({
        ru: 'Получаемый уровень образования',
        en: 'Level of education',
        cn: 'Level of education'
    }),
    course: localize({
        ru: 'Курс',
        en: 'Course',
        cn: 'Course'
    }),
    faculty: localize({
        ru: 'Факультет',
        en: 'Faculty',
        cn: 'Faculty'
    }),
    specialty: localize({
        ru: 'Направление подготовки / Специальность',
        en: 'Field of study / Specialty',
        cn: 'Field of study / Specialty'
    }),
    averageScore: localize({
        ru: 'Средний балл',
        en: 'Average score',
        cn: 'Average score'
    }),
    schoolClass: localize({
        ru: 'Класс',
        en: 'Class',
        cn: 'Class'
    }),
    areaPractice: localize({
        ru: 'Желаемое направление практики',
        en: 'Desired direction of practice',
        cn: 'Desired direction of practice'
    }),
    problemSolve: localize({
        ru: 'Какие задачи ты бы хотел/хотела решать?',
        en: 'What problems would you like to solve?',
        cn: 'What problems would you like to solve?'
    }),
    experience: localize({
        ru: 'Расскажи о своем опыте',
        en: 'Tell us about your experience',
        cn: 'Tell us about your experience'
    }),
    resume: localize({
        ru: 'Резюме',
        en: 'Resume',
        cn: 'Resume'
    }),
    agreement: localize({
        ru: 'Я даю согласие на обработку своих персональных данных. С <z-link href="/personal-data-policy/">Политикой ООО «ИНК» в области обработки персональных данных</z-link> и текстом <z-link href="/personal-data-policy/">согласия на обработку персональных данных</z-link> ознакомлен, возражений не имею.',
        en: 'I agree to the processing of my personal data. With <z-link href="/personal-data-policy/">Policy of LLC "INK" in the field of personal data processing</z-link> and the text of <z-link href="/personal-data-policy/">consent to the processing of personal data</z-link>',
        cn: 'I agree to the processing of my personal data. With <z-link href="/personal-data-policy/">Policy of LLC "INK" in the field of personal data processing</z-link> and the text of <z-link href="/personal-data-policy/">consent to the processing of personal data</z-link>'
    }),
    submit: localize({
        ru: 'Отправить',
        en: 'Submit',
        cn: 'Submit'
    }),
    specialtySingle: localize({
        ru: 'Специальность',
        en: 'Specialty',
        cn: 'Specialty'
    }),
    school: localize({
        ru: 'школа',
        en: 'school',
        cn: 'school'
    })
}

const vuzNameList = [
    {
        disabled: false,
        id: 'Иркутский государственный аграрный университет имени А.А. Ежевского',
        selected: false,
        text: 'Иркутский государственный аграрный университет имени А.А. Ежевского',
        xmlId: 'Иркутский государственный аграрный университет имени А.А. Ежевского',
    },
    {
        disabled: false,
        id: 'Иркутский авиационный техникум',
        selected: false,
        text: 'Иркутский авиационный техникум',
        xmlId: 'Иркутский авиационный техникум',
    },
    {
        disabled: false,
        id: 'Иркутский аграрный техникум',
        selected: false,
        text: 'Иркутский аграрный техникум',
        xmlId: 'Иркутский аграрный техникум',
    },
    {
        disabled: false,
        id: 'Иркутский гидрометеорологический техникум',
        selected: false,
        text: 'Иркутский гидрометеорологический техникум',
        xmlId: 'Иркутский гидрометеорологический техникум',
    },
    {
        disabled: false,
        id: 'Иркутский национальный исследовательский технический университет',
        selected: false,
        text: 'Иркутский национальный исследовательский технический университет',
        xmlId: 'Иркутский национальный исследовательский технический университет',
    },
    {
        disabled: false,
        id: 'Иркутский государственный университет',
        selected: false,
        text: 'Иркутский государственный университет',
        xmlId: 'Иркутский государственный университет',
    },
    {
        disabled: false,
        id: 'Иркутский государственный университет путей сообщения',
        selected: false,
        text: 'Иркутский государственный университет путей сообщения',
        xmlId: 'Иркутский государственный университет путей сообщения',
    },
    {
        disabled: false,
        id: 'Геологоразведочный техникум(филиал ИРНИТУ)',
        selected: false,
        text: 'Геологоразведочный техникум(филиал ИРНИТУ)',
        xmlId: 'Геологоразведочный техникум(филиал ИРНИТУ)',
    },
    {
        disabled: false,
        id: 'Машиностроительный колледж (филиал ИРНИТУ)',
        selected: false,
        text: 'Машиностроительный колледж (филиал ИРНИТУ)',
        xmlId: 'Машиностроительный колледж (филиал ИРНИТУ)',
    },
    {
        disabled: false,
        id: 'Иркутский техникум авиастроения и материалообработки',
        selected: false,
        text: 'Иркутский техникум авиастроения и материалообработки',
        xmlId: 'Иркутский техникум авиастроения и материалообработки',
    },
    {
        disabled: false,
        id: 'Иркутский техникум архитектуры и строительства',
        selected: false,
        text: 'Иркутский техникум архитектуры и строительства',
        xmlId: 'Иркутский техникум архитектуры и строительства',
    },
    {
        disabled: false,
        id: '«‎ИРКУТСКИЙ ТЕХНИКУМ МАШИНОСТРОЕНИЯ ИМ.Н.П.ТРАПЕЗНИКОВА»',
        selected: false,
        text: '«‎ИРКУТСКИЙ ТЕХНИКУМ МАШИНОСТРОЕНИЯ ИМ.Н.П.ТРАПЕЗНИКОВА»',
        xmlId: '«‎ИРКУТСКИЙ ТЕХНИКУМ МАШИНОСТРОЕНИЯ ИМ.Н.П.ТРАПЕЗНИКОВА»',
    },
    {
        disabled: false,
        id: 'Иркутский колледж автомобильного транспорта и дорожного строительства',
        selected: false,
        text: 'Иркутский колледж автомобильного транспорта и дорожного строительства',
        xmlId: 'Иркутский колледж автомобильного транспорта и дорожного строительства',
    },
    {
        disabled: false,
        id: 'СИБИРСКИЙ КОЛЛЕДЖ ТРАНСПОРТА И СТРОИТЕЛЬСТВА',
        selected: false,
        text: 'СИБИРСКИЙ КОЛЛЕДЖ ТРАНСПОРТА И СТРОИТЕЛЬСТВА',
        xmlId: 'СИБИРСКИЙ КОЛЛЕДЖ ТРАНСПОРТА И СТРОИТЕЛЬСТВА',
    },
    {
        disabled: false,
        id: 'Иркутский техникум транспорта и строительства',
        selected: false,
        text: 'Иркутский техникум транспорта и строительства',
        xmlId: 'Иркутский техникум транспорта и строительства',
    },
    {
        disabled: false,
        id: 'Иркутский энергетический колледж',
        selected: false,
        text: 'Иркутский энергетический колледж',
        xmlId: 'Иркутский энергетический колледж',
    },
    {
        disabled: false,
        id: 'АНГАРСКИЙ ГОСУДАРСТВЕННЫЙ ТЕХНИЧЕСКИЙ УНИВЕРСИТЕТ',
        selected: false,
        text: 'АНГАРСКИЙ ГОСУДАРСТВЕННЫЙ ТЕХНИЧЕСКИЙ УНИВЕРСИТЕТ',
        xmlId: 'АНГАРСКИЙ ГОСУДАРСТВЕННЫЙ ТЕХНИЧЕСКИЙ УНИВЕРСИТЕТ',
    },
    {
        disabled: false,
        id: 'Ангарский индустриальный техникум',
        selected: false,
        text: 'Ангарский индустриальный техникум',
        xmlId: 'Ангарский индустриальный техникум',
    },
    {
        disabled: false,
        id: 'Ангарский политехнический техникум',
        selected: false,
        text: 'Ангарский политехнический техникум',
        xmlId: 'Ангарский политехнический техникум',
    },
    {
        disabled: false,
        id: 'Бодайбинский горный техникум',
        selected: false,
        text: 'Бодайбинский горный техникум',
        xmlId: 'Бодайбинский горный техникум',
    },
    {
        disabled: false,
        id: 'Братский государственный университет',
        selected: false,
        text: 'Братский государственный университет',
        xmlId: 'Братский государственный университет',
    },
    {
        disabled: false,
        id: 'Братский промышленно-гуманитарный техникум',
        selected: false,
        text: 'Братский промышленно-гуманитарный техникум',
        xmlId: 'Братский промышленно-гуманитарный техникум',
    },
    {
        disabled: false,
        id: 'Усть-Кутский промышленный техникум',
        selected: false,
        text: 'Усть-Кутский промышленный техникум',
        xmlId: 'Усть-Кутский промышленный техникум',
    },
    {
        disabled: false,
        id: 'Черемховский техникум промышленной индустрии и сервиса',
        selected: false,
        text: 'Черемховский техникум промышленной индустрии и сервиса',
        xmlId: 'Черемховский техникум промышленной индустрии и сервиса',
    },
    {
        disabled: false,
        id: 'УСТЬ-ИЛИМСКИЙ ТЕХНИКУМ ЛЕСОПРОМЫШЛЕННЫХ ТЕХНОЛОГИЙ И СФЕРЫ УСЛУГ',
        selected: false,
        text: 'УСТЬ-ИЛИМСКИЙ ТЕХНИКУМ ЛЕСОПРОМЫШЛЕННЫХ ТЕХНОЛОГИЙ И СФЕРЫ УСЛУГ',
        xmlId: 'УСТЬ-ИЛИМСКИЙ ТЕХНИКУМ ЛЕСОПРОМЫШЛЕННЫХ ТЕХНОЛОГИЙ И СФЕРЫ УСЛУГ',
    },
    {
        disabled: false,
        id: 'БРАТСКИЙ ИНДУСТРИАЛЬНО-МЕТАЛЛУРГИЧЕСКИЙ ТЕХНИКУМ',
        selected: false,
        text: 'БРАТСКИЙ ИНДУСТРИАЛЬНО-МЕТАЛЛУРГИЧЕСКИЙ ТЕХНИКУМ',
        xmlId: 'БРАТСКИЙ ИНДУСТРИАЛЬНО-МЕТАЛЛУРГИЧЕСКИЙ ТЕХНИКУМ',
    },
    {
        disabled: false,
        id: 'Ангарский техникум рекламы и промышленных технологий',
        selected: false,
        text: 'Ангарский техникум рекламы и промышленных технологий',
        xmlId: 'Ангарский техникум рекламы и промышленных технологий',
    },
    {
        disabled: false,
        id: 'Химико-технологический техникум, Саянск',
        selected: false,
        text: 'Химико-технологический техникум, Саянск',
        xmlId: 'Химико-технологический техникум, Саянск',
    },
    {
        disabled: false,
        id: 'Филиал Иркутского техникума архитектуры и строительства в г. Шелехов',
        selected: false,
        text: 'Филиал Иркутского техникума архитектуры и строительства в г. Шелехов',
        xmlId: 'Филиал Иркутского техникума архитектуры и строительства в г. Шелехов',
    },
    {
        disabled: false,
        id: 'ГАПОУ РС(Я) "МРТК" Региональный технический колледж в г. Мирном',
        selected: false,
        text: 'ГАПОУ РС(Я) "МРТК" Региональный технический колледж в г. Мирном',
        xmlId: 'ГАПОУ РС(Я) "МРТК" Региональный технический колледж в г. Мирном',
    },
    {
        disabled: false,
        id: 'ГАПОУ РС (Я) "МРТК " филиал Светлинский филиал энергетики, нефти и газа',
        selected: false,
        text: 'ГАПОУ РС (Я) "МРТК " филиал Светлинский филиал энергетики, нефти и газа',
        xmlId: 'ГАПОУ РС (Я) "МРТК " филиал Светлинский филиал энергетики, нефти и газа',
    },
    {
        disabled: false,
        id: 'ГАПОУ РС (Я) «МРТК» филиал«Айхальский филиал алмазодобывающей промышленности',
        selected: false,
        text: 'ГАПОУ РС (Я) «МРТК» филиал«Айхальский филиал алмазодобывающей промышленности',
        xmlId: 'ГАПОУ РС (Я) «МРТК» филиал«Айхальский филиал алмазодобывающей промышленности',
    },
    {
        disabled: false,
        id: 'ГАПОУ РС (Я) «МРТК" филиал Удачнинский горнотехнический филиал',
        selected: false,
        text: 'ГАПОУ РС (Я) «МРТК" филиал Удачнинский горнотехнический филиал',
        xmlId: 'ГАПОУ РС (Я) «МРТК" филиал Удачнинский горнотехнический филиал',
    },
    {
        disabled: false,
        id: '«‎Южно-Якутский технологический колледж, Нерюнгри»',
        selected: false,
        text: '«‎Южно-Якутский технологический колледж, Нерюнгри»',
        xmlId: '«‎Южно-Якутский технологический колледж, Нерюнгри»',
    },
    {
        disabled: false,
        id: 'Политехнический институт (филиал) Северо-Восточного федерального университета имени М.К. Аммосова в г. Мирном',
        selected: false,
        text: 'Политехнический институт (филиал) Северо-Восточного федерального университета имени М.К. Аммосова в г. Мирном',
        xmlId: 'Политехнический институт (филиал) Северо-Восточного федерального университета имени М.К. Аммосова в г. Мирном',
    },
    {
        disabled: false,
        id: 'Томский политехнический техникум',
        selected: false,
        text: 'Томский политехнический техникум',
        xmlId: 'Томский политехнический техникум',
    },
    {
        disabled: false,
        id: 'Национальный исследовательный Томский политехнический университет',
        selected: false,
        text: 'Национальный исследовательный Томский политехнический университет',
        xmlId: 'Национальный исследовательный Томский политехнический университет',
    },
    {
        disabled: false,
        id: 'Усть-Кутский институт водного транспорта - филиал ФГБОУ ВО «‎СГУВТ»',
        selected: false,
        text: 'Усть-Кутский институт водного транспорта - филиал ФГБОУ ВО «‎СГУВТ»',
        xmlId: 'Усть-Кутский институт водного транспорта - филиал ФГБОУ ВО «‎СГУВТ»',
    },
    {
        disabled: false,
        id: 'Казанский государственный технический университет им.А.Н.Туполева',
        selected: false,
        text: 'Казанский государственный технический университет им.А.Н.Туполева',
        xmlId: 'Казанский государственный технический университет им.А.Н.Туполева',
    },
    {
        disabled: false,
        id: 'Уфимский государственный нефтяной технический университет',
        selected: false,
        text: 'Уфимский государственный нефтяной технический университет',
        xmlId: 'Уфимский государственный нефтяной технический университет',
    },
    {
        disabled: false,
        id: 'other',
        selected: false,
        text: 'Другое учебное заведение',
        xmlId: 'Другое учебное заведение',
    },
]

const levelEducationOptions = [
    {
        disabled: false,
        id: 'Бакалавр',
        selected: true,
        text: 'Бакалавр',
        xmlId: 'Бакалавр',
    },
    {
        disabled: false,
        id: 'Магистратура',
        selected: false,
        text: 'Магистратура',
        xmlId: 'Магистратура',
    },
    {
        disabled: false,
        id: 'Специалитет',
        selected: false,
        text: 'Специалитет',
        xmlId: 'Специалитет',
    },
]

const areaPracticeOptions = [
    {
        disabled: false,
        id: 'Вахта',
        selected: true,
        text: 'Вахта',
    },
    {
        disabled: false,
        id: 'Офис',
        selected: false,
        text: 'Офис',
    },
]

const institutionOptions = [
    {
        disabled: false,
        id: 'vuz',
        selected: true,
        text: textLocalize.vuz.label,
        xmlId: 'vuz',
    },
    {
        disabled: false,
        id: 'ssuz',
        selected: false,
        text: textLocalize.ssuz.label,
        xmlId: 'ssuz',
    },
    {
        disabled: false,
        id: 'school',
        selected: false,
        text: textLocalize.school,
        xmlId: 'school',
    },
]

export { vuzNameList, textLocalize, levelEducationOptions, areaPracticeOptions, institutionOptions }
